import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, EventEmitter, Inject, Output, PLATFORM_ID } from '@angular/core';
import { EMPTY, timer } from 'rxjs';
import { take } from 'rxjs/operators';

@Directive({
  selector: '[appBs5Modal]',
  exportAs: 'appBs5Modal',
})
export class Bs5ModalDirective {
  private isBrowser: boolean;
  private el: HTMLElement;
  private targetDom: HTMLElement;
  private _modal: any;
  /** 是否為顯示狀態 */
  isShow = true;
  /** show.bs.modal */
  @Output() showed = new EventEmitter<void>();
  /** shown.bs.modal */
  @Output() showned = new EventEmitter<void>();
  /** hide.bs.modal */
  @Output() hideed = new EventEmitter<void>();
  /** hidden.bs.modal */
  @Output() hiddened = new EventEmitter<void>();
  
  constructor(
    private elRef: ElementRef,
    @Inject(PLATFORM_ID) protected platformId: any,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngAfterViewInit() {
    this.el = this.elRef.nativeElement;

    if (this.el.classList.contains('show')) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }

    if (this.isBrowser) {
      this._modal = new (window as any)['bootstrap'].Modal(this.el);

      this.el.addEventListener('show.bs.modal', () => {
        this.showed.emit();
      });
      this.el.addEventListener('shown.bs.modal', () => {
        timer(150).pipe(take(1)).subscribe(t => {
          this.showned.emit();
          this.isShow = true;
        });
      });
      this.el.addEventListener('hide.bs.modal', () => {
        this.hideed.emit();
      });
      this.el.addEventListener('hidden.bs.modal', () => {
        timer(150).pipe(take(1)).subscribe(t => {
          this.hiddened.emit();
          this.isShow = false;
        });
      });
    }
  }

  show() {
    if (this.isBrowser) {
      this._modal.show();
      return this.showned.asObservable().pipe(take(1));
    }
    return EMPTY;
  }

  hide() {
    if (this.isBrowser) {
      this._modal.hide();
      return this.hiddened.asObservable().pipe(take(1));
    }
    return EMPTY;
  }

  toggle() {
    if (this.isBrowser) {
      this._modal.toggle();
    }
  }
}
